import React from 'react';
import { TrendingUp, Zap } from 'lucide-react';

const ConsumptionInsight = ({ insights, recommendation }) => {
    return (
        <div className="bg-white rounded-3xl p-8 border border-[#D1E0FF] shadow-sm mt-8">
            <div className="flex items-center gap-4 mb-6">
                <div className="w-10 h-10 bg-[#7C9DFF] rounded-full flex items-center justify-center">
                    <TrendingUp className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 tracking-tight">Consumption Insight</h3>
            </div>

            <ul className="space-y-2 mb-8 ml-6">
                {(insights || []).map((insight, idx) => {
                    const parts = insight.split('(');
                    return (
                        <li key={idx} className="flex items-start gap-2 text-[15px] font-medium text-gray-800">
                            <span className="text-gray-900 mt-1.5 w-1.5 h-1.5 rounded-full bg-black flex-shrink-0"></span>
                            <span>
                                <span className="font-bold">{parts[0]}</span>
                                {parts[1] && <span className="text-gray-500">({parts[1]}</span>}
                            </span>
                        </li>
                    );
                })}
            </ul>

            <div className="flex items-start gap-3 text-sm text-gray-800">
                <Zap className="w-5 h-5 text-[#FDB022] fill-[#FDB022] flex-shrink-0 mt-0.5" />
                <div className="text-[15px] leading-relaxed">
                    <span className="font-bold text-gray-900 italic">Recommended Action: </span>
                    <span className="font-medium text-gray-600">{recommendation}</span>
                </div>
            </div>
        </div>
    );
};

export default ConsumptionInsight;
